import actionCreatorFactory from "typescript-fsa"

const actionCreator = actionCreatorFactory()
// Reduxの見積結果state更新アクション
export const planActions = {
  updatePlan: actionCreator<any>("ACTIONS_UPDATE_PLAN"),
  updatePage: actionCreator<string>("ACTIONS_UPDATE_PAGE"),
  reset: actionCreator("ACTIONS_PLAN_RESET")
}

export default planActions
